import { Component, ContentChildren, Input, QueryList, inject } from '@angular/core';
import { AuthModule } from '@forgerock/backstage-ui-core';
import { Tab, tabLookup } from '../../model/tabs';
import {
  SearchParamsContainerComponent
} from '../../search-params/search-params-container/search-params-container.component';
import { LayoutTabComponent } from '../layout-tab/layout-tab.component';

@Component({
  selector: 'app-layout-tab-container',
  templateUrl: './layout-tab-container.component.html',
  styleUrls: [ './layout-tab-container.component.scss' ],
  imports: [ AuthModule ]
})
export class LayoutTabContainerComponent {
  container = inject(SearchParamsContainerComponent);

  @Input() currentTab: Tab;
  @ContentChildren(LayoutTabComponent) tabComponents: QueryList<LayoutTabComponent>;

  tabLookup = tabLookup;

  setTab(tab: Tab) {
    this.currentTab = tab;
    this.container.setParams({ tab });
  }
}
